import dayjs from 'dayjs';

export const dateCell = (record) => {
	let value = record;	
	if(record && record.hasOwnProperty('value'))
		value = record.value;	
	return (
		<span>{dayjs(value).format('YYYY-MM-DD')}</span>
	)
}